import { Injectable } from '@angular/core';
import { ReportingApiService } from './reporting.api.services';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { ReportingAction, reportingActions } from './reporting.actions';
import { createApiCallEffects } from 'src/app/common/store/generic.effects';
import { IReportingState } from './reporting.reducer';

@Injectable()
export class ReportingEffects {
  constructor(
    private readonly store: Store<IReportingState>,
    private readonly reportingApiService: ReportingApiService,
    private readonly actions$: Actions<ReportingAction>,
  ) {}

  getReportByFilter = createApiCallEffects(
    this,
    this.actions$,
    reportingActions.getReportByFilter,
    this.reportingApiService.getReportByEntity,
  );
  getReportPeopleByRegime = createApiCallEffects(
    this,
    this.actions$,
    reportingActions.getReportPeopleByRegime,
    this.reportingApiService.getReportByEntity,
  );
  getReportFemalePeopleByAge = createApiCallEffects(
    this,
    this.actions$,
    reportingActions.getReportFemalePeopleByAge,
    this.reportingApiService.getReportByEntity,
  );
  getReportMalePeopleByAge = createApiCallEffects(
    this,
    this.actions$,
    reportingActions.getReportMalePeopleByAge,
    this.reportingApiService.getReportByEntity,
  );
  getLeadsByDayAndHoursRange = createApiCallEffects(
    this,
    this.actions$,
    reportingActions.getLeadsByDayAndHoursRange,
    this.reportingApiService.getReportByEntity,
  );
  getPeriods = createApiCallEffects(
    this,
    this.actions$,
    reportingActions.getPeriods,
    this.reportingApiService.getPeriods,
  );
  getReportLeadsByCity = createApiCallEffects(
    this,
    this.actions$,
    reportingActions.getReportLeadsByCity,
    this.reportingApiService.getReportByEntity,
  );
  getLeadCount = createApiCallEffects(
    this,
    this.actions$,
    reportingActions.getLeadCount,
    this.reportingApiService.getReportKpi,
  );
  getContractsCount = createApiCallEffects(
    this,
    this.actions$,
    reportingActions.getConversionRateCount,
    this.reportingApiService.getReportKpi,
  );
  getRawContractCount = createApiCallEffects(
    this,
    this.actions$,
    reportingActions.getRawContractCount,
    this.reportingApiService.getReportKpi,
  );
  getValidatedContractCount = createApiCallEffects(
    this,
    this.actions$,
    reportingActions.getValidatedContractCount,
    this.reportingApiService.getReportKpi,
  );

  getReportLeadsByCategory = createApiCallEffects(
    this,
    this.actions$,
    reportingActions.getReportLeadsByCategory,
    this.reportingApiService.getReportByEntity,
  );
  getReportContractsByProductCategory = createApiCallEffects(
    this,
    this.actions$,
    reportingActions.getReportContractsByProductCategory,
    this.reportingApiService.getReportByEntity,
  );

  getReportLeadsBySource = createApiCallEffects(
    this,
    this.actions$,
    reportingActions.getReportLeadsBySource,
    this.reportingApiService.getReportByEntity,
  );
  getReportContractsBySource = createApiCallEffects(
    this,
    this.actions$,
    reportingActions.getReportContractsBySource,
    this.reportingApiService.getReportByEntity,
  );
  getReportLeadsBySalesPerson = createApiCallEffects(
    this,
    this.actions$,
    reportingActions.getReportLeadsBySalesPerson,
    this.reportingApiService.getReportByEntity,
  );
  getReportContractsBySalesPerson = createApiCallEffects(
    this,
    this.actions$,
    reportingActions.getReportContractsBySalesPerson,
    this.reportingApiService.getReportByEntity,
  );
  getReportMonthlyProgress = createApiCallEffects(
    this,
    this.actions$,
    reportingActions.getReportMonthlyProgress,
    this.reportingApiService.getReportWithGroupedLabelWithValue,
  );
  getReportSalesTotalAndObjectives = createApiCallEffects(
    this,
    this.actions$,
    reportingActions.getReportSalesTotalAndObjectives,
    this.reportingApiService.getReportWithGroupedLabelWithValue,
  );
  getSalesPerformance = createApiCallEffects(
    this,
    this.actions$,
    reportingActions.getSalesPerformance,
    this.reportingApiService.getSalesPerformance,
  );
  getSalesPerformanceFacetItems = createApiCallEffects(
    this,
    this.actions$,
    reportingActions.getSalesPerformanceFacetItems,
    this.reportingApiService.getSalesPerformanceFacetItems,
  );
  getCallsPerformance = createApiCallEffects(
    this,
    this.actions$,
    reportingActions.getCallsPerformance,
    this.reportingApiService.getCallsPerformance,
  );
  getMarketingPerformance = createApiCallEffects(
    this,
    this.actions$,
    reportingActions.getMarketingPerformance,
    this.reportingApiService.getMarketingPerformance,
  );
}
